module.exports = __webpack_public_path__ + "img/tyre_net_logo.03118bc6.png";